import { PaStatus, PaStatusLabels } from "../enums/paStatus";
import { PaStatusBucket, PaStatusBucketLabels } from "../enums/paStatusBucket";
import { RouteVia, RouteViaLabels } from "../enums/routeVia";
import { BadgeOption } from "./submissionSummaryOptions";

export const ROUTE_VIA_OPTIONS: BadgeOption[] = [
  {
    id: RouteVia.CMM,
    text: RouteViaLabels[RouteVia.CMM],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: RouteVia.SURESCRIPTS,
    text: RouteViaLabels[RouteVia.SURESCRIPTS],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: RouteVia.PROMPTPA,
    text: RouteViaLabels[RouteVia.PROMPTPA],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: RouteVia.PHONEPA,
    text: RouteViaLabels[RouteVia.PHONEPA],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: RouteVia.FAXPA,
    text: RouteViaLabels[RouteVia.FAXPA],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: RouteVia.OTHERS,
    text: RouteViaLabels[RouteVia.OTHERS],
    textColor: "black",
    bgColor: "white",
  },
];

export const PA_STATUS_OPTIONS: BadgeOption[] = [
  {
    id: PaStatus.APPROVED,
    text: PaStatusLabels[PaStatus.APPROVED],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatus.DENIED,
    text: PaStatusLabels[PaStatus.DENIED],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatus.PENDING,
    text: PaStatusLabels[PaStatus.PENDING],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatus.AUTH_NOT_REQUIRED,
    text: PaStatusLabels[PaStatus.AUTH_NOT_REQUIRED],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatus.ONSHORE_ASSISTANCE,
    text: PaStatusLabels[PaStatus.ONSHORE_ASSISTANCE],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatus.NA_OUTCOME,
    text: PaStatusLabels[PaStatus.NA_OUTCOME],
    textColor: "black",
    bgColor: "white",
  },
];

export const PA_STATUS_BUCKET_OPTIONS: BadgeOption[] = [
  {
    id: PaStatusBucket.APPROVAL_ON_FILE,
    text: PaStatusBucketLabels[PaStatusBucket.APPROVAL_ON_FILE],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.DENIAL_ON_FILE,
    text: PaStatusBucketLabels[PaStatusBucket.DENIAL_ON_FILE],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.NOT_COVERED_PLAN_EXCLUSION,
    text: PaStatusBucketLabels[PaStatusBucket.NOT_COVERED_PLAN_EXCLUSION],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.MEDICALLY_UNNECESSARY,
    text: PaStatusBucketLabels[PaStatusBucket.MEDICALLY_UNNECESSARY],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.STEP_THERAPY_REQUIRED,
    text: PaStatusBucketLabels[PaStatusBucket.STEP_THERAPY_REQUIRED],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.DONE_BY_ONSHORE,
    text: PaStatusBucketLabels[PaStatusBucket.DONE_BY_ONSHORE],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.ASKED_CLIENT_ASSISTANCE,
    text: PaStatusBucketLabels[PaStatusBucket.ASKED_CLIENT_ASSISTANCE],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.EXPIRED,
    text: PaStatusBucketLabels[PaStatusBucket.EXPIRED],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.PROCESSOR_ERROR,
    text: PaStatusBucketLabels[PaStatusBucket.PROCESSOR_ERROR],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.UNABLE_TO_PROCESS_CALL_REQUIRED,
    text: PaStatusBucketLabels[PaStatusBucket.UNABLE_TO_PROCESS_CALL_REQUIRED],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.CANCELLED_CLOSED_DUPLICATE,
    text: PaStatusBucketLabels[PaStatusBucket.CANCELLED_CLOSED_DUPLICATE],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.ELIGIBILITY_ERROR,
    text: PaStatusBucketLabels[PaStatusBucket.ELIGIBILITY_ERROR],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.PROGRAM_PREREQUISITE,
    text: PaStatusBucketLabels[PaStatusBucket.PROGRAM_PREREQUISITE],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.NO_REVIEW_NEEDED,
    text: PaStatusBucketLabels[PaStatusBucket.NO_REVIEW_NEEDED],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.BENEFIT_LIMITATION,
    text: PaStatusBucketLabels[PaStatusBucket.BENEFIT_LIMITATION],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.UNSPECIFIED_SYSTEM_FAILURE,
    text: PaStatusBucketLabels[PaStatusBucket.UNSPECIFIED_SYSTEM_FAILURE],
    textColor: "black",
    bgColor: "white",
  },
  {
    id: PaStatusBucket.OTHERS,
    text: PaStatusBucketLabels[PaStatusBucket.OTHERS],
    textColor: "black",
    bgColor: "white",
  },
];
